import type { ChangelogEntry } from "../types";

/** Påminnelsen om manglende timer kom også til dem som hadde ført. */
export const MANGLENDE_TIMER_VARSEL_2026_10: ChangelogEntry = {
  id: "2026-10-27-manglende-timer-varsel",
  date: "2026-10-27",
  title: "Påminnelsen om manglende timer kommer bare når timer faktisk mangler",
  summary:
    "Boksen «Du mangler timer» dukket opp for alle ansatte, også dem som hadde ført timer begge dagene. Nå teller føringene igjen, og boksen kommer bare når en arbeidsdag er helt tom.",
  sections: [
    {
      heading: "Timeføring",
      items: [
        {
          title: "Førte timer teller med i påminnelsen",
          kind: "rettet",
          body: "Påminnelsen så ikke føringene dine og meldte derfor begge de siste arbeidsdagene som tomme. E-postvarselet var ikke rammet.",
        },
      ],
    },
  ],
};
